import { useState } from "react";
import { getActualSetValue } from "../services/productionService";

const useGetActualSetCount =() => {
    const [actualSetCount, setActualCount] = useState(0);

    const loadActualSetCount = async (parameters) => {

        try {
            const data = await getActualSetValue(parameters);
            if (data && data.length > 0) {
                setActualCount(data[0].actual_set);

            }
        } catch (error) {
            console.error("Failed to load employee list:", error);
        }

    };

    return {
        actualSetCount,
        setActualCount,
        loadActualSetCount,
    };

}
export default useGetActualSetCount;